import { Button } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';

export const deleteTableCommand = ({ editor, range }) =>
  range ? editor.chain().focus().deleteRange(range).deleteTable().run() : editor.chain().focus().deleteTable().run();

const DeleteTable = ({ editor, showLabel = false, isExtension = false }) => {
  return (
    <Button
      className={`editor-toolbar-btn-container !bg-transparent`}
      icon={<CloseOutlined className="text-gray-800 text-xs" />}
      onClick={isExtension ? () => {} : () => deleteTableCommand({ editor })}
      size="small"
      type="text"
    >
      {showLabel && (
        <div className="editor-toolbar-btn-label">
          <FormattedMessage id="TABLE_DELETE" defaultMessage="Delete table" />
        </div>
      )}
    </Button>
  );
};

export default DeleteTable;
